import type { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdIntl3 } from './pages'

type TIdToPageMapIntl3 = Record<PageIdIntl3, TPageMapValue>

export const ID_TO_PAGE_MAP_INTL_3: TIdToPageMapIntl3 = {
  [PageIdIntl3.ANALYZING]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/urge/AnalyzingPage').then((m) => ({
        default: m.AnalyzingPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/urge/AnalyzingPage'),
  },
  [PageIdIntl3.START]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/urge/StartPage').then((m) => ({
        default: m.StartPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/urge/StartPage'),
  },
  [PageIdIntl3.PUZZLES_ENJOYMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages').then(
        (m) => ({
          default: m.PuzzlesEnjoymentPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages'),
  },
  [PageIdIntl3.APPLY_KNOWLEDGE_REAL_LIFE]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages').then(
        (m) => ({
          default: m.ApplyKnowledgeRealLifePage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages'),
  },
  [PageIdIntl3.NOTICE_PATTERNS]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages').then(
        (m) => ({
          default: m.NoticePatternsPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages'),
  },
  [PageIdIntl3.STAY_CURIOUS]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages').then(
        (m) => ({
          default: m.StayCuriousPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages'),
  },
  [PageIdIntl3.LONG_FOCUS]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/likertEmojiQuestionPages').then(
        (m) => ({
          default: m.LongFocusPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_3/pages/urge/PersonalizeTestFeedbackPage'),
  },
  [PageIdIntl3.PERSONALIZE_TEST_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/urge/PersonalizeTestFeedbackPage').then(
        (m) => ({
          default: m.PersonalizeTestFeedbackPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_3/pages/urge/PersonalizeTestFeedbackPage'),
  },
  [PageIdIntl3.QUESTION_1]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question1Page').then((m) => ({
        default: m.Question1Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question1Page'),
  },
  [PageIdIntl3.QUESTION_2]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question2Page').then((m) => ({
        default: m.Question2Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question1Page'),
  },
  [PageIdIntl3.QUESTION_3]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question3Page').then((m) => ({
        default: m.Question3Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question3Page'),
  },
  [PageIdIntl3.QUESTION_4]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question4Page').then((m) => ({
        default: m.Question4Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question4Page'),
  },
  [PageIdIntl3.SPEED_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/urge/SpeedFeedbackPage').then((m) => ({
        default: m.SpeedFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/urge/SpeedFeedbackPage'),
  },
  [PageIdIntl3.QUESTION_5]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question5Page').then((m) => ({
        default: m.Question5Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question5Page'),
  },
  [PageIdIntl3.QUESTION_6]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question6Page').then((m) => ({
        default: m.Question6Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question6Page'),
  },
  [PageIdIntl3.QUESTION_7]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question7Page').then((m) => ({
        default: m.Question7Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question7Page'),
  },
  [PageIdIntl3.QUESTION_8]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question8Page').then((m) => ({
        default: m.Question8Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question8Page'),
  },
  [PageIdIntl3.QUESTION_9]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question9Page').then((m) => ({
        default: m.Question9Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question9Page'),
  },
  [PageIdIntl3.QUESTION_10]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question10Page').then((m) => ({
        default: m.Question10Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question10Page'),
  },
  [PageIdIntl3.QUESTION_11]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question11Page').then((m) => ({
        default: m.Question11Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question11Page'),
  },
  [PageIdIntl3.QUESTION_12]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question12Page').then((m) => ({
        default: m.Question12Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question12Page'),
  },
  [PageIdIntl3.SMARTNESS_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/urge/SmartnessFeedbackPage').then((m) => ({
        default: m.SmartnessFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/urge/SmartnessFeedbackPage'),
  },
  [PageIdIntl3.QUESTION_13]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question13Page').then((m) => ({
        default: m.Question13Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question13Page'),
  },
  [PageIdIntl3.QUESTION_14]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question14Page').then((m) => ({
        default: m.Question14Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question14Page'),
  },
  [PageIdIntl3.QUESTION_15]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question15Page').then((m) => ({
        default: m.Question15Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question15Page'),
  },
  [PageIdIntl3.QUESTION_16]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question16Page').then((m) => ({
        default: m.Question16Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question16Page'),
  },
  [PageIdIntl3.QUESTION_17]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question17Page').then((m) => ({
        default: m.Question17Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question17Page'),
  },
  [PageIdIntl3.QUESTION_18]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question18Page').then((m) => ({
        default: m.Question18Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question18Page'),
  },
  [PageIdIntl3.QUESTION_19]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question19Page').then((m) => ({
        default: m.Question19Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question19Page'),
  },
  [PageIdIntl3.QUESTION_20]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question20Page').then((m) => ({
        default: m.Question20Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question20Page'),
  },
  [PageIdIntl3.LOGICAL_SKILLS_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/urge/LogicSkillFeedback').then((m) => ({
        default: m.LogicalSkillsFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/urge/LogicSkillFeedback'),
  },
  [PageIdIntl3.QUESTION_21]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question21Page').then((m) => ({
        default: m.Question21Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question21Page'),
  },
  [PageIdIntl3.QUESTION_22]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question22Page').then((m) => ({
        default: m.Question22Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question22Page'),
  },
  [PageIdIntl3.QUESTION_23]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question23Page').then((m) => ({
        default: m.Question23Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question23Page'),
  },
  [PageIdIntl3.QUESTION_24]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question24Page').then((m) => ({
        default: m.Question24Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question24Page'),
  },
  [PageIdIntl3.QUESTION_25]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/Question25Page').then((m) => ({
        default: m.Question25Page,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/Question25Page'),
  },
  [PageIdIntl3.AGE_QUESTION]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/AgeQuestionPage').then((m) => ({
        default: m.AgeQuestionPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/questions/AgeQuestionPage'),
  },
  [PageIdIntl3.EDUCATION_QUESTION]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/questions/EducationQuestionPage').then(
        (m) => ({
          default: m.EducationQuestionPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_3/pages/questions/EducationQuestionPage'),
  },
  [PageIdIntl3.DISCOVER_FEEDBACKS]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/urge/DiscoverFeedbacksPage').then((m) => ({
        default: m.DiscoverFeedbacksPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/urge/DiscoverFeedbacksPage'),
  },
  [PageIdIntl3.PREPARE_FLOW]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/prepareFlow/PrepareFlow').then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdIntl3.EMAIL]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/email/EmailPage'),
  },
  [PageIdIntl3.OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/offer/OfferPage').then((m) => ({
        default: m.OfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/offer/OfferPage'),
  },
  [PageIdIntl3.SPECIAL_DISCOUNT]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/specialDiscount/SpecialDiscountPage').then(
        (m) => ({
          default: m.SpecialDiscountPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_3/pages/specialDiscount/SpecialDiscountPage'),
  },
  [PageIdIntl3.CANCEL_OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/cancelOffer/CancelOfferPage').then((m) => ({
        default: m.CancelOfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/cancelOffer/CancelOfferPage'),
  },
  [PageIdIntl3.PAYMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/payment/PaymentPage').then((m) => ({
        default: m.PaymentPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/payment/PaymentPage'),
  },
  [PageIdIntl3.REGISTRATION]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/account/AccountNove8'),
  },
  [PageIdIntl3.NAME_ENTRY]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/name/NamePage').then((m) => ({
        default: m.NamePage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/name/NamePage'),
  },
  [PageIdIntl3.CERTIFICATE]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/certificate/CertificatePage').then((m) => ({
        default: m.CertificatePage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/certificate/CertificatePage'),
  },
  [PageIdIntl3.REPORT]: {
    Component: lazy(() =>
      import('cohorts/intl_3/pages/report/ReportPage').then((m) => ({
        default: m.ReportPage,
      })),
    ),
    preload: () => import('cohorts/intl_3/pages/report/ReportPage'),
  },
}
